import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "milestone-progress-reports" }
const _hoisted_2 = { class: "milestone-progress-reports__select" }
const _hoisted_3 = {
  key: 0,
  class: "milestone-progress-reports__nolist"
}
const _hoisted_4 = {
  key: 1,
  class: "milestone-progress-reports__nocompanies"
}
const _hoisted_5 = { class: "milestone-progress-reports__wrapper" }
const _hoisted_6 = { class: "milestone-progress-reports__header" }
const _hoisted_7 = { class: "milestone-progress-reports__content" }
const _hoisted_8 = { class: "milestone-progress-reports__title" }
const _hoisted_9 = {
  key: 0,
  class: "milestone-progress-reports__title-primary"
}
const _hoisted_10 = {
  key: 1,
  class: "milestone-progress-reports__title-primary"
}
const _hoisted_11 = { class: "milestone-progress-reports__title-secondary" }
const _hoisted_12 = { class: "milestone-progress-reports__charts" }
const _hoisted_13 = {
  key: 0,
  class: "milestone-progress-reports__tables"
}
const _hoisted_14 = { class: "milestone-progress-reports__data" }
const _hoisted_15 = { class: "milestone-progress-reports__data__inner" }
const _hoisted_16 = {
  key: 0,
  class: "milestone-progress-reports__data__highlights"
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "milestone-progress-reports__data__assesment" }
const _hoisted_19 = {
  key: 0,
  class: "milestone-progress-reports__data__assesment__table",
  assessmentData: ""
}

import { onBeforeMount, ref } from "vue";
import { watch } from "vue";
import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import PxTable from "@/components/px-table/px-table.vue";
import PxButton from "@/components/px-button/px-button.vue";
import PxNavigationTab from "@/components/px-navigation-tab/px-navigation-tab.vue";
import PxCustomBarChart from "@/components/charts/custom-bar-chart/custom-bar-chart.vue";

import { userManager } from "@/modules/authentication/user-manager";
import { CompanyListState } from "@/modules/company-lists/services/store/company-list/company-list.modules";
import { createProgressTableData } from "@/modules/charts-dashboard/utils/milestone-reports.table";
import { createHiglightsData } from "@/modules/charts-dashboard/utils/milestone-reports.table";
import { MilestoneReportsState } from "@/modules/charts-dashboard/services/store/milestone/milestone.module";
import { createLevelsChartData } from "@/modules/charts-dashboard/utils/milestone-reports.chart";
import { createMilestonesChartData } from "@/modules/charts-dashboard/utils/milestone-reports.chart";
import { createAssessmentTableData } from "@/modules/charts-dashboard/utils/milestone-reports.table";
// import { createLevelsOverTimeChartData } from "@/modules/charts-dashboard/utils/milestone-reports.chart";

import type { IMilestoneReports } from "@/modules/charts-dashboard/services/data/milestone-reports/milestone.interface";
import type { TMilestoneDetailsTab } from "@/modules/milestone-planner/services/data/milestones/milestone.interface";

import { MILESTONE_DETAILS_TABS } from "@/modules/milestone-planner/services/data/milestones/milestone.interface";


export default /*@__PURE__*/_defineComponent({
  __name: 'milestone-progress-reports.view',
  setup(__props) {

const store = useStore();
const router = useRouter();

const milestoneAndProgressReportData = computed<IMilestoneReports>(() =>
  store.get(MilestoneReportsState.Getter.VALUE),
);

const navigationTabItems = ref([
  // {
  //   id: MILESTONE_DETAILS_TABS.LEVELS_OVER_TIME,
  //   title: "Levels over Time",
  // },
  {
    id: MILESTONE_DETAILS_TABS.LEVELS,
    title: "Levels at Start vs End",
  },
  {
    id: MILESTONE_DETAILS_TABS.MILESTONES,
    title: "Levels & Milestones Achieved",
  },
]);

// The company lists
const companyLists = computed(() => store.get(CompanyListState.Getter.VALUES));
// weather the current user has pro subscription or not
const proUser = computed(userManager.isProUser);
// The currently selected company list
const selectedList = ref();
const selectedListUid = ref();
// Disable company list selection
const companyListDisabled = ref(false);
const loading = ref(false);
const showEmptyState = ref(false);
const selectedTab = ref<TMilestoneDetailsTab>(navigationTabItems.value[0].id);
// Pre calculated data for the different charts
const levelsChart = ref<any>();
const milestonesChart = ref<any>();
// const levelsOverTimeChart = ref<any>();
// Precalculated data for the tables
const highlightsData = ref<any>();
const assessmentData = ref<any>();
const progressTableData = ref<any>();

function handleTabSelection(val: any) {
  selectedTab.value = val;
}

function newListHandler() {
  router.push({ path: "/lists", query: { form_open: "true" } });
}

function openListHandler() {
  router.push({ path: `/lists/${selectedList.value.uid}` });
}

// Just initialization stuff, selecting default values and modes
const initialize = () => {
  selectedTab.value = navigationTabItems.value[0].id;
  if (companyLists.value?.length > 0) {
    selectedList.value = companyLists.value[0];
  }

  const dataIsLoaded =
    milestoneAndProgressReportData.value?.companies.length > 0;
  if (dataIsLoaded) {
    prepareData(!proUser.value);
  }

  store.dispatch(CompanyListState.Action.GET_VALUES);
};

// Load new data for the new company list selected
const handleListChange = () => {
  if (proUser.value) {
    if (companyLists.value.length > 0) {
      if (selectedListUid.value) {
        selectedList.value = companyLists.value.filter(
          (l: (typeof companyLists.value)[0]) =>
            l.uid === selectedListUid.value,
        )[0];

        if (selectedList.value?.companies.length > 0) {
          if (proUser.value) {
            store.dispatch(
              MilestoneReportsState.Action.GET_VALUE,
              selectedList?.value.uid,
            );
          } else {
            prepareData(!proUser.value);
          }
        }
      } else {
        selectedListUid.value = companyLists.value[0].uid;
      }
    }
  } else {
    prepareData(!proUser.value);
  }
};

// Take the milestone and level progress data an create suitable
// data to be viewed in the charts and the tables
const prepareData = (prepareDummyData: boolean) => {
  // Chart Data
  levelsChart.value = createLevelsChartData(
    milestoneAndProgressReportData.value,
    prepareDummyData,
  );
  milestonesChart.value = createMilestonesChartData(
    milestoneAndProgressReportData.value,
    prepareDummyData,
  );
  // levelsOverTimeChart.value = createLevelsOverTimeChartData(
  //   milestoneAndProgressReportData.value,
  //   !proUser.value,
  //   // true,
  // );

  // Table data
  highlightsData.value = createHiglightsData(
    milestoneAndProgressReportData.value,
    prepareDummyData,
  );
  assessmentData.value = createAssessmentTableData(
    milestoneAndProgressReportData.value,
    prepareDummyData,
  );
  progressTableData.value = createProgressTableData(
    milestoneAndProgressReportData.value,
    selectedList.value?.title,
    prepareDummyData,
  );
};

onBeforeMount(initialize);
watch(companyLists, handleListChange);
watch(selectedListUid, handleListChange);
watch(milestoneAndProgressReportData, () => prepareData(!proUser.value));

return (_ctx: any,_cache: any) => {
  const _component_ElOption = _resolveComponent("ElOption")!
  const _component_ElSelect = _resolveComponent("ElSelect")!
  const _component_PxIcon = _resolveComponent("PxIcon")!
  const _component_RequestProcessesModal = _resolveComponent("RequestProcessesModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t(`chartsDashboard.select[0]`)), 1),
        _createVNode(_component_ElSelect, {
          modelValue: selectedListUid.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedListUid).value = $event)),
          disabled: companyListDisabled.value,
          filterable: "",
          "default-first-option": "",
          "popper-class": "milestone-progress-reports__select-list"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyLists.value, (list) => {
              return (_openBlock(), _createBlock(_component_ElOption, {
                key: list.uid,
                value: list.uid,
                label: list.title
              }, null, 8, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"])
      ])
    ]),
    (companyLists.value?.length === 0 && proUser.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "milestone-progress-reports__nolist__icon" }, [
            _createElementVNode("img", { src: "img/no-matches.svg" })
          ], -1)),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "milestone-progress-reports__nolist__text" }, [
            _createElementVNode("span", null, "No lists available."),
            _createElementVNode("span", null, " You havent created any lists yet. Start by creating a new list to keep track of relevant companies ")
          ], -1)),
          _createVNode(PxButton, {
            type: "green",
            class: "milestone-progress-reports__nolist__cta",
            onClick: newListHandler
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PxIcon, {
                size: 18,
                name: "plus-white"
              }),
              _cache[2] || (_cache[2] = _createTextVNode(" NEW LIST ", -1))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (selectedList.value && selectedList.value.companies.length === 0 && proUser.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "milestone-progress-reports__nocompanies__icon" }, [
            _createElementVNode("img", { src: "img/no-matches.svg" })
          ], -1)),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "milestone-progress-reports__nocompanies__text" }, [
            _createElementVNode("span", null, "No companies in the list."),
            _createElementVNode("span", null, " Start adding companies to track your network’s milestone progress. ")
          ], -1)),
          _createVNode(PxButton, {
            type: "green",
            class: "milestone-progress-reports__nocompanies__cta",
            onClick: openListHandler
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode(" OPEN LIST ", -1)
            ]))]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    ((selectedList.value && selectedList.value.companies.length > 0) || !proUser.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 2,
          "element-loading-background": "#fafafa",
          class: _normalizeClass(["mileston-progress-reports__content", {
        'mileston-progress-reports__loading': loading.value,
      }])
        }, [
          (!loading.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(PxNavigationTab, {
                      "navigation-tabs": navigationTabItems.value,
                      "selected-tab": selectedTab.value,
                      "onUpdate:selectedTab": handleTabSelection
                    }, null, 8, ["navigation-tabs", "selected-tab"])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      (selectedTab.value === 'levels-date-range')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("h1", null, _toDisplayString(selectedList.value?.title) + " company levels at start vs at end ", 1),
                            _cache[8] || (_cache[8] = _createElementVNode("p", null, " Level progress represents growth across the eight VIL categories. ", -1))
                          ]))
                        : _createCommentVNode("", true),
                      (selectedTab.value === 'levels-milestone')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("h1", null, _toDisplayString(selectedList.value?.title) + " company levels & milestones achieved ", 1),
                            _cache[9] || (_cache[9] = _createElementVNode("p", null, " Level progress represents growth across the eight VIL categories. ", -1))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("h1", null, _toDisplayString(assessmentData.value?.assessmentDates?.start) + " - " + _toDisplayString(assessmentData.value?.assessmentDates?.end), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      (selectedTab.value === _unref(MILESTONE_DETAILS_TABS).LEVELS_OVER_TIME)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                        : _createCommentVNode("", true),
                      (selectedTab.value === _unref(MILESTONE_DETAILS_TABS).LEVELS)
                        ? (_openBlock(), _createBlock(PxCustomBarChart, {
                            key: 1,
                            type: levelsChart.value?.type,
                            data: levelsChart.value?.data,
                            options: levelsChart.value?.options,
                            plugins: levelsChart.value?.plugins
                          }, null, 8, ["type", "data", "options", "plugins"]))
                        : _createCommentVNode("", true),
                      (selectedTab.value === _unref(MILESTONE_DETAILS_TABS).MILESTONES)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "milestone-progress-reports__chart-label" }, [
                              _createElementVNode("span", null, "Levels"),
                              _createElementVNode("span", null, "Milestone")
                            ], -1)),
                            _createVNode(PxCustomBarChart, {
                              type: milestonesChart.value?.type,
                              data: milestonesChart.value?.data,
                              options: milestonesChart.value?.options,
                              plugins: milestonesChart.value?.plugins
                            }, null, 8, ["type", "data", "options", "plugins"])
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    (progressTableData.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createVNode(PxTable, { data: progressTableData.value }, null, 8, ["data"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      (highlightsData.value && highlightsData.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(highlightsData.value, (data, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "milestone-progress-reports__highlights__section"
                              }, [
                                _createElementVNode("span", {
                                  class: "milestone-progress-reports__highlights__title",
                                  innerHTML: `${data.icon} ${data.title}`
                                }, null, 8, _hoisted_17),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.items, (item, itemIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: itemIndex,
                                    class: "milestone-progress-reports__highlights__sub-item"
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString(item.title), 1),
                                    _createElementVNode("span", null, _toDisplayString(item.subtitle), 1)
                                  ]))
                                }), 128))
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_18, [
                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "milestone-progress-reports__data__assesment__header" }, " Assesment Data ", -1)),
                        (assessmentData.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createVNode(PxTable, { data: assessmentData.value }, null, 8, ["data"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                (showEmptyState.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_RequestProcessesModal, {
                        visibility: showEmptyState.value,
                        "onUpdate:visibility": _cache[1] || (_cache[1] = ($event: any) => ((showEmptyState).value = $event))
                      }, null, 8, ["visibility"]),
                      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "process-reports__overlay" }, null, -1))
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ], 2)), [
          [_directive_loading, loading.value]
        ])
      : _createCommentVNode("", true)
  ]))
}
}

})